import axios from 'axios';
import { cloneDeep } from 'lodash';

import { RefreshTokenService } from '@ply-io/ply-front-shared-utilities';

import ErrorHandlingService, { ERROR_CODES, STATUS_CODES, LOGOUT_REASON } from '@/utils/error-handling-service';
import PubSub, { PUB_SUB_EVENTS } from '@/utils/pub-sub-service';

const refreshTokenService = new RefreshTokenService();

/* eslint-disable no-undef */
const { VUE_APP_API, VUE_APP_APIGW } = process.env;

if (!VUE_APP_API || !VUE_APP_APIGW) {
	throw new Error('Missing api URLs');
}

const promiseCapability = () => {
	const x = {};
	x.promise = new Promise((a, b) => {
		x.resolve = a;
		x.reject = b;
	});
	return x;
};

const createRefreshApi = () => {
	const refreshApi = axios.create({
		baseURL: VUE_APP_API,
		headers: cloneDeep(axios.defaults.headers),
		withCredentials: true,
	}); // as basic as it gets

	refreshApi.interceptors.response.use(
		(response) => response,
		(err) => tokenErrorHandler({ err, logoutReason: LOGOUT_REASON.tokenExpired })
	);
	return refreshApi;
};

const refreshApi = createRefreshApi();
const refreshTokenCallback = (refreshToken) => refreshTokenService.callRefresh(refreshApi, refreshToken);
const refreshCallback = async () => {
	if (PubSub.countSubscriptions(PUB_SUB_EVENTS.REFRESH_TOKEN) > 0) {
		// if we refresh or in a mode we didn't register yet we don't want to wait for the promise
		const promiseObject = promiseCapability();
		PubSub.publish(PUB_SUB_EVENTS.REFRESH_TOKEN, { promise: promiseObject, refreshToken: refreshTokenCallback });
		const token = await promiseObject.promise;
		return token;
	}
};

//Public
export const refreshForRunner = refreshTokenCallback;
export const tokenStructure = (token) => refreshTokenService.tokenStructure(token);
export const refreshTokenMiddleware = async (config) => refreshTokenService.apiRequestMiddleware(config, refreshCallback);
export const tokenErrorHandler = ({ err, logoutReason = null }) => {
	if (
		ErrorHandlingService.extractStatusCode(err) === STATUS_CODES.UNAUTHORIZED &&
		ErrorHandlingService.extractErrorCode(err) === ERROR_CODES.TOKEN_INVALID &&
		PubSub.countSubscriptions(PUB_SUB_EVENTS.TOKEN_INVALID) > 0
	) {
		PubSub.publish(PUB_SUB_EVENTS.TOKEN_INVALID, { logoutReason });
	}
	throw err;
};
